import(/* webpackMode: "eager" */ "/home/interim/frontend/app/clients/page.tsx");
